import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { translate } from 'services/i18nService';

import IconTokns from '../../../../../../images/profilePage/icon-tokns.png';

import styles from './index.css';


const RegularPrice = (props) => {
  const { discountedPrice, price } = props;

  const discountedPriceElement = useMemo(() => {
    if (!discountedPrice) {
      return null;
    }

    return (
      <span>
        {' '}{discountedPrice}
      </span>
    );
  }, [discountedPrice]);

  const priceTextClases = classNames({
    [styles.priceText]: true,
    [styles.lineThrough]: discountedPrice,
  });

  const text = price || translate('profile.profile.videos.free');

  return (
    <div className={styles.regularPrice}>
      <img
        alt="tokens"
        className={styles.tokensIcon}
        src={IconTokns}
      />

      <span className={priceTextClases}>
        {text}
      </span>

      {discountedPriceElement}
    </div>
  );
};

RegularPrice.propTypes = {
  discountedPrice: PropTypes.number.isRequired,
  price: PropTypes.number.isRequired,
};

export default memo(RegularPrice);
